import { User } from 'store/user/types';

export const hasPermissions = (user: Pick<User, 'roles'>, permissionName: string): boolean =>
  user.roles.some(({ permissions }) => permissions.some(({ name }) => name === permissionName));
